
export const JOBS_SUCCESS = "JOBS_SUCCESS";
export const JOBS_REQUEST = "JOBS_REQUEST";
export const JOBS_FAILURE = "JOBS_FAILURE";



